import React, { useMemo } from 'react';
import { twJoin } from 'tailwind-merge';

import { TextSubtext } from '@dbt-labs/sourdough';

import { ExposureNode } from '@/hooks/discovery/useExposureTileQuery';

interface LastCheckedTimeProps {
  exposure: ExposureNode;
  className?: string;
}

export const toHumanReadable = (date: Date): string => {
  const now = new Date(Date.now());
  const diff = now.getTime() - date.getTime();
  const days = Math.floor(diff / (24 * 60 * 60 * 1000));

  let dayString = '';

  switch (days) {
    case 0:
      if (now.getDate() === date.getDate()) {
        dayString = 'today';
      } else {
        dayString = 'yesterday';
      }
      break;
    case 1:
      if (now.getDate() - 1 === date.getDate()) {
        dayString = 'yesterday';
      } else {
        dayString = `${days.toString()} day ago`;
      }
      break;
    default:
      dayString = `${days.toString()} ${days === 1 ? `day` : `days`} ago`;
      break;
  }

  let hours = date.getHours();
  const minutes = date.getMinutes();
  let timePeriod = 'am';

  if (hours > 12) {
    timePeriod = 'pm';
    hours -= 12;
  } else if (hours === 12) {
    timePeriod = 'pm';
  } else if (hours === 0) {
    hours = 12; // midnight
  }

  if (minutes < 10) {
    return `${dayString} at ${hours}:0${minutes} ${timePeriod}`;
  }
  return `${dayString} at ${hours}:${minutes} ${timePeriod}`;
};

const getLastCheckSubTitle = (exposure: ExposureNode): string => {
  const lastCheck = exposure.maxSnapshottedAt;
  const date = lastCheck ? new Date(lastCheck) : null;
  const humanReadable = date ? toHumanReadable(date) : null;
  return `Last check completed ${humanReadable}`;
};

const LastCheckedTime: React.FC<LastCheckedTimeProps> = ({ exposure, className }) => {
  const lastCheckSubtitle = useMemo(() => getLastCheckSubTitle(exposure), [exposure]);

  return (
    <div className={twJoin('text-dbt-gray font-normal', className)}>
      <TextSubtext
        size="xs"
        loadingDimensions={{
          width: 200,
          height: 12,
        }}
      >
        {lastCheckSubtitle}
      </TextSubtext>
    </div>
  );
};

export default LastCheckedTime;
